import { createAction } from "@reduxjs/toolkit";
import type { AdminCreateInternalTrainingBody } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminCreateInternalTraining = createApiThunk<string, AdminCreateInternalTrainingBody>(
  "internalTrainings/createInternalTraining",
  async (training: AdminCreateInternalTrainingBody, { extra: { adminRepository } }) => {
    return adminRepository!.createInternalTraining(training);
  },
);

export const adminResetCreateInternalTraining = createAction("internalTrainings/resetCreateInternalTraining");
